export default "assets/images/icons/facebook-81213a98.svg";